module.exports = __webpack_public_path__ + "media/images/countrysquared/mn-eeecce4e3a9478cccef3fad35250f720.svg";